<ion-header>
  <ion-toolbar color="primary">
    <ion-item color="primary">
      <ion-icon class="cursor-pointer" slot="end" name="close-circle-outline" (click)="dismissModal()"></ion-icon>
      <ion-label>Email {{ contactName }}</ion-label>
    </ion-item>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="myForm">
    <ion-grid>
      <ion-row color="primary" justify-content-center>
        <ion-col align-self-center>
          <div padding>
            <p>A copy of this email will be sent to {{ from }}</p>
            <ion-item>
              <ion-select
                formControlName="subjectOptions"
                (ionChange)="onOptionChange()"
                label="Subject:"
                label-placement="floating"
              >
                <ion-select-option *ngFor="let subject of subjectOptions" [value]="subject">
                  {{ subject }}
                </ion-select-option>
              </ion-select>
            </ion-item>
            @if (otherSubjectRequired) {
            <ion-item>
              <ion-input
                formControlName="otherSubject"
                label="Enter your own subject:"
                label-placement="floating"
                maxlength="80"
              ></ion-input>
            </ion-item>
            <div class="message-error-count-container">
              <app-form-errors [errors]="errorMessages.otherSubject" [item]="otherSubject"></app-form-errors>
              <ion-text slot="end" class="character-count">
                <small>{{ otherSubject.value ? otherSubject.value.length : 0 }} out of 80</small>
              </ion-text>
            </div>
            }

            <ion-item lines="none">
              <ion-select
                formControlName="emailTo"
                (ionChange)="updateContact()"
                multiple
                label="To:"
                label-placement="floating"
              >
                <ion-select-option *ngFor="let t of to" value="{{ t.value }}">
                  {{ t.value }} ({{ t.display }})
                </ion-select-option>
              </ion-select>
            </ion-item>
            <app-form-errors [errors]="errorMessages.emailTo" [item]="emailTo"></app-form-errors>
            <div class="ion-padding">
              <ion-textarea
                label="Message:"
                label-placement="floating"
                fill="outline"
                autoGrow="true"
                inputmode="textbox"
                formControlName="message"
                maxlength="560"
                aria-label="message"
              ></ion-textarea>

              <div class="message-error-count-container">
                <app-form-errors [errors]="errorMessages.message" [item]="message" lines="none"></app-form-errors>
                <ion-text slot="end" class="character-count">
                  <small>{{ message.value ? message.value.length : 0 }} out of 560</small>
                </ion-text>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
<ion-footer>
  <ion-button expand="full" (click)="onSubmit()" [disabled]="myForm.invalid">
    @if (isSubmitting) { <ion-spinner slot="start" class="ion-margin-end"></ion-spinner> Sending } @else {
    <ion-icon slot="start" name="mail"></ion-icon> Send } to {{ contactName }}
    <ion-ripple-effect></ion-ripple-effect>
  </ion-button>
</ion-footer>
